import { render, staticRenderFns } from "./App.vue?vue&type=template&id=39e8ac51&lang=pug"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=39e8ac51&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../.nvm/versions/node/v16.20.2/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports